import { Data as ArticleData, StreamElement } from '@root/modules/article/types/article';

export default function getStreamElement(article: ArticleData) {
  const attributes = article.settings;

  const isStream = attributes.streamEventCode || (attributes.streamEventStart && attributes.streamEventEnd);
  if (isStream) {
    const streamElement: StreamElement = {};
    streamElement.videoCode = isStream;
    streamElement.provider = isStream.split(':')[0];
    streamElement.start = attributes.streamEventStart;
    streamElement.end = attributes.streamEventEnd;
    streamElement.hasPostLiveRecording = attributes.hasPostLiveRecording;

    return streamElement;
  }

  return null;
}
